<!-- 教育局-订单管理 -->
<template>
  <div>
    <div class="index">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="订单编号">
            <el-input
              v-model="queryParams.orderNo"
              placeholder="请输入"
              style="width: 200px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="课程名称">
            <el-input
              v-model="queryParams.cname"
              placeholder="请输入"
              style="width: 200px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select
              v-model="queryParams.status"
              clearable
              placeholder="请选择"
              class="label"
              style="width: 205px"
            >
              <el-option
                v-for="(item, i) in statusList"
                :key="i + 'state'"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="区域">
            <el-select
              style="margin-right: 10px"
              v-model="queryParams.address.proviceCode"
              @change="handleProviceChange"
              clearable
              filterable
              placeholder="请选择省"
            >
              <el-option
                v-for="item in proviceList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              style="margin-right: 10px"
              v-model="queryParams.address.cityCode"
              @change="handleCityChange"
              clearable
              filterable
              placeholder="请选择市"
            >
              <el-option
                v-for="item in cityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryParams.address.areaCode"
              @change="handleAreaChange"
              clearable
              filterable
              placeholder="请选择区"
            >
              <el-option
                v-for="item in areaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <br /> -->
          <el-form-item label="提供方">
            <el-input
              v-model="queryParams.orgName"
              placeholder="请输入"
              style="width: 200px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="订单时间">
            <el-date-picker
              v-model="queryParams.date"
              type="daterange"
              style="width: 280px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
            <download-excel
              :data="excelpage"
              class="download-excel"
              :fields="json_fields"
              name="订单管理.xls"
            >
              <el-button type="primary" size="small" icon="download">
                导出
              </el-button>
            </download-excel>
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" id="exportOutTable" style="width: 100%">
            <el-table-column
              prop="orderNo"
              label="订单编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cname"
              label="课程"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orgName"
              label="课程提供方"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="studentName"
              label="学生姓名"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="schoolName"
              label="学校"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="amountTotal"
              label="订单总金额(元)"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="订单时间"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ dayjs(scope.row.createTime).format("YYYY.MM.DD HH:mm") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="订单状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/education/index.js";
import { getNextAreaInfo } from "@/api/user/userCenter";
import dayjs from "dayjs";
export default {
  components: {},
  data() {
    return {
      queryParams: {
        orderNo: "",
        cname: "",
        status: "",
        date: "",
        startDate: "",
        endDate: "",
        orgName: "",
        address: {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
        }, //覆盖区域控件选择的地址(默认值)
      },
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      proviceList: [], //省列表数据
      cityList: [], //市列表数据
      areaList: [], //区列表数据
      excelpage: [], // 存放用于导出excel的数据
      json_fields: {
        订单编号: "orderNo", //常规字段
        课程: "cname", //支持嵌套属性
        课程提供方: "orgName",
        学生姓名: "studentName",
        学校: "schoolName", //常规字段
        订单总金额: "amountTotal", //支持嵌套属性
        订单时间: "createTime",
        订单状态: "status",
      },
      statusList: [
        { value: "UNPAID", label: "待支付" },
        { value: "PAYED", label: "已支付" },
        { value: "REVOKE", label: "已关闭" },
        { value: "CLOSED", label: "已完成" },
      ],
      tableData: [],
      tabName: "支付完成",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {},
  created() {
    this.getDataList();
    // 用户中心获取全部省的数据
    getNextAreaInfo({ area_code: "0" }).then((res) => {
      if (res.code == "000000") {
        this.proviceList = res.result;
      }
    });
    if (
      sessionStorage.getItem("user_level") === "99" ||
      ["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1
    ) {
      this.tableData = [];
    }
  },
  methods: {
    dayjs,
    async getDataList() {
      let _this = this.queryParams;
      let startTime = "",
        endTime = "";
      if (_this.date) {
        startTime = dayjs(_this.date[0]).format("YYYY-MM-DD");
        endTime = dayjs(_this.date[1]).format("YYYY-MM-DD");
      }
      let params = {
        loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
        platformCode: sessionStorage.getItem("platformCode"),
        usessionid: sessionStorage.getItem("usessionid"),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: startTime,
        endTime: endTime,
        orgName: _this.orgName,
        cname: _this.cname,
        type: _this.status, //查询类型(枚举值): PAYED.支付完成 UNPAID.待支付，REVOKE.交易关闭, REFUND.退款中, REFUNDED.已退
        // cityCode: _this.address.cityCode,
        // areaCode: _this.address.areaCode,
        orderNo: _this.orderNo,
      };
      for (var key in params) {
        if (params[key] == "") {
          delete params[key];
        }
      }
      let { result, data } = await api.handleOrderList(params);
      if (result === "000000") {
        this.tableData = data.list;
        let list = data.list;
        this.getExlData(list);
        this.totalPage = data.total;
      }
    },
    async getExlData(data) {
      try {
        this.excelpage = data || [];
        this.excelpage.forEach((item) => {
          item.status = this.statusFilter(item.status);
          item.amountTotal = item.amountTotal / 100 || 0;
          item.createTime = dayjs(item.createTime).format("YYYY.MM.DD HH:mm");
        });
      } catch (err) {
        console.log(err);
      }
    },
    statusFilter(type) {
      const typeMap = {
        UNPAID: "待支付",
        PAYED: "已支付",
        REVOKE: "已关闭",
        CLOSED: "已完成",
      };
      return typeMap[type] || "无";
    },
    async handleProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.cityList = result;
      }
      this.queryParams.address.cityCode = "";
      this.queryParams.address.cityName = "";
      this.queryParams.address.areaCode = "";
      this.queryParams.address.areaName = "";
    },
    async handleCityChange(areaCode) {
      var obj = {};
      obj = this.cityList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.areaList = result;
      }
      this.queryParams.address.areaCode = "";
      this.queryParams.address.areaName = "";
    },
    async handleAreaChange(areaCode) {
      var obj = {};
      obj = this.areaList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.areaName = obj.area_name;
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    tabClick(item) {
      this.tabName = item.name;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .header_text {
    span {
      color: #4991e1;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}

.Homeboxtop_nav_tab {
  span {
    padding-bottom: 15px;
  }
}
.radio_nav {
  height: 40px;
  display: flex;
  align-items: center;
  p {
    line-height: 28px;
    padding: 0px 12px;
    border-radius: 26px;
    margin: 0 5px;
    cursor: pointer;
  }
  .active {
    background: #4696ec;
    color: #fff;
  }
}
.download-excel {
  display: inline-block;
  margin-left: 10px;
}
</style>
